// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#fff","menuText":"#858d96","menuActiveText":"#fff"};